<template>
  <div id="container">
    <div class="navbar">
      <div class="nav_wrapper margin">
        <h4 class="title">用户服务协议</h4>
      </div>
    </div>
    <div class="argeement">
      <p class="title1">用户服务协议</p>
      <p class="title2">协议须知：</p>
      <p>北京棋开德胜科技有限公司在此特别提醒用户认真阅读、充分理解本《 用户服务协议》(下称“本协议”)中各条款，特别涉及免除或者限制北京棋开德胜科技有限公司责任的条款、对用户权利限制的条款、约定争议解决方式的条款等。请您审慎阅读并选择接受或不接受本协议（未成年人应在法定监护人陪同下阅读）。除非您接受本协议所有条款，否则您无权使用北京棋开德胜科技有限公司提供的相关用户服务。您使用北京棋开德胜科技有限公司服务的行为将视为对本协议的接受，并同意接受本协议各项条款的约束。</p>
      <p>本协议是您与北京棋开德胜科技有限公司之间所订立的关于您使用北京棋开德胜科技有限公司提供的用户服务的协议。本协议描述用户在享受北京棋开德胜科技有限公司提供的相关服务过程中的权利义务。</p>
      <p>1.释义</p>
      <p>1.1 “本协议”是指《用户服务协议》，是用户接受北京棋开德胜科技有限公司产品和服务时适用的通用条款。文化部根据《网络游戏管理暂行办法》（文化部令第49号）制定的《网络游戏服务格式化协议必备条款》构成本协议的组成部分。</p>
      <p>1.2 “用户”或“您”是指通过北京棋开德胜科技有限公司提供的获取软件授权和注册的途径获得软件产品及账号授权许可后使用北京棋开德胜科技有限公司相关服务的个人或组织。</p>
      <p>1.3 “用户服务”或“相关服务”是指用户在北京棋开德胜科技有限公司所开发/经营的网络游戏中使用北京棋开德胜科技有限公司所提供的包括但不限于账号注册、资料修改、登录游戏、购买游戏道具等服务。</p>
      <p>1.4 “用户同意”的方式有：</p>
      （a）通过点击“我同意”或者其他方式接受本协议及北京棋开德胜科技有限公司发布的其他服务条款
      （b）用户通过电子邮件、电话、传真、即时通信等方式所作的书面或口头表示；
      （c）本《协议》或其他服务声明中有“默认同意”条款，用户对此无异议的；
      （d）其他北京棋开德胜科技有限公司与用户均认可的方式。
      <p>用户应当明确：用户点击“同意”按钮并按照相关注册程序成功注册，即表示用户无条件接受了本协议及北京棋开德胜科技有限公司所公布的各项相关管理规定，并愿意受其约束。如果发生纠纷，用户不得以未仔细阅读为由进行抗辩。</p>
      <p>2. 知识产权声明</p>
      <p>北京棋开德胜科技有限公司所提供的服务的相关著作权、专利权、商标、商业秘密及其它任何权利，均属北京棋开德胜科技有限公司所有。非经北京棋开德胜科技有限公司网络同意，用户不得对任何该信息、资料、软件、产品和服务进行修改、拷贝、散布、传送、展示、复制、发行、授权、制作衍生品、移转或销售。北京棋开德胜科技有限公司有权 收集并合理使用向用户提供服务过程中所产生并储存于北京棋开德胜科技有限公司服务器中的数据信息（包括但不仅限于账号资料、游戏数据及系统衍生数据等信息）。</p>
      <p>3. 用户的基本义务</p>
      <p>3.1 用户需自行配备注册和使用网络所需的各项计算机及网络设备，并自行负担上网所需的各项费用</p>
      <p>3.2 用户应根据本协议或北京棋开德胜科技有限公司所公布的各项相关管理规定支付相应费用。</p>
      <p>3.3 账号注册</p>
      <p>3.3.1 用户承诺以其真实有效的身份证件注册成为北京棋开德胜科技有限公司的用户，并保证所提供的个人身份资料信息真实、完整、有效，并依照法律规定和本协议所约定对所提供的信息 承担相应的法律责任。用户以其真实身份注册成为北京棋开德胜科技有限公司用户后，需要修改所提供的个人资料信息的，应提供相应的文件以证明自己的资料信息和将要更改的资料 信息的真实性；如用户无法提供上述信息，北京棋开德胜科技有限公司有权拒绝为用户修改个人资料信息。如果用户提供的资料不准确、不真实、不合法有效，用户需承担因此引起的 相应后果，北京棋开德胜科技有限公司保留终止用户使用北京棋开德胜科技有限公司各项服务及追究用户法律责任的权利。</p>
      <p>3.3.2 对账号的使用权，归该账号居民身份证号码所对应之居民身份证持有者所有。用户应充分认识到身份证信息是账号所有权的主要凭证。</p>
      <p>3.3.3 若任何人因无法提供当前账号所对应的居民身份证信息证实其对账号拥有合法权利或授权，导致北京棋开德胜科技有限公司无法为其提供或继续提供服务的，北京棋开德胜科技有限公司将不承担因此产生的任何责任。用他人身份证号码及杜撰虚假身份证号码注册的用户的权益在游戏中将得不到任何保障。对提供虚假身份证号码的用户，北京棋开德胜科技有限公司有权随时中止或终止向用户提供本协议项下的服务（包括收费服务）而无需对用户或任何第三方承担任何责任；对用他人身份证号码注册的用户，应该身份证号码对应之本人请求，北京棋开德胜科技有限公司有权随时中止或终止向该身份证号码对应之账号提供本协议项下的服务（包括收费服务）而无需对用户或任何第三方承担任何责任。</p>
      <p>3.4 用户有义务妥善保管及正确、安全地使用在注册服务时获得的账号及密码，并为此账号及密码登入系统后所产生的一切行为或活动依法享有权利和承担责任。
      <p>3.5 为维护自身权益，用户不应将账号及密码泄漏或提供第三人知悉或出借或转让与他人使用，如因用户自身过错而导致账号或密码泄漏而给用户自身造成损失，用户应 自行承担责任。北京棋开德胜科技有限公司员工不会在电话或邮件中询问用户的密码，如果用户遗失了密码，北京棋开德胜科技有限公司针对处理此问题之服务保留要求支付额外费用的权利。</p>
      <p>3.6 若用户发现账号或密码遭他人非法使用或有异常使用的情形，应立即通知北京棋开德胜科技有限公司，并提交该账号为本人所有的有关证明，以便申请该账号的暂停使用，对账号暂停使用前用户自身或任何第三方因此而遭受的损失，北京棋开德胜科技有限公司不承担赔偿责任。若用户没有提供其个人有效身份证件或者用户提供的个人有效身份证件与所注册的身份 信息不一致的，北京棋开德胜科技有限公司有权拒绝用户上述请求。</p>
      <p>3.7 用户同意了本协议的条款之后，北京棋开德胜科技有限公司将授予允许用户以一个合法账号而获得北京棋开德胜科技有限公司提供的服务的权利。用户不得对包括但不仅限于北京棋开德胜科技有限公司的网站及提供的软件进行修改、还原工程、译码、反向组译、复制、散布或传播。</p>
      <p>3.8 用户不可以使用任何第三方程序登录或使用北京棋开德胜科技有限公司所提供的服务。用户不可以使用北京棋开德胜科技有限公司的任何知识产权，来创造或提供相同或类似的服务，如仿真服务器等。 用户不可以对北京棋开德胜科技有限公司服务器采取任何的攻击行为，或是尝试使北京棋开德胜科技有限公司服务器过度负荷。用户在拥有合法账号的情况下，可以在北京棋开德胜科技有限公司的服务器上传使用服务所必须的资料，但资料的内容不得存在下列情形：</p>
      (a)侵犯任何第三者的知识产权或公众/私人权利;
      (b)违反任何法律、法规或善良风俗;
      (c)包含任何毁谤他人、性骚扰、种族歧视或对孩童有不良影响的内容;
      (d)包含病毒、木马、定时炸弹等可能对北京棋开德胜科技有限公司游戏运营系统造成伤害或影响其稳定性的内容。
      北京棋开德胜科技有限公司可以依照上传内容违法或违约的严重性采取任何包括但不限于终止用户账号使用权的动作。用户在此授权北京棋开德胜科技有限公司使用任何有关用户上传的内容，不会以此为由追究北京棋开德胜科技有限公司侵权责任或其他相关责任。
      <p>3.9 用户充分理解并同意：北京棋开德胜科技有限公司会按照国家有关法律法规的要求将用户的实名注册信息运用于防沉迷系统之中，即北京棋开德胜科技有限公司可能会根据用户的实名注册信息判断用户是否年满18周岁，从而决定是否对用户的游戏账号予以防沉迷限制。</p>
      <p>3.10 本协议未明确授予用户的权利均由北京棋开德胜科技有限公司保留。</p>
      <p>4. 用户信息保护</p>
      <p>4.1 根据协议条款的约定，北京棋开德胜科技有限公司有权审查用户注册所提供的身份信息是否真实、有效，并应积极地采取技术与管理等合理措施保障用户账号的安全、有效；用户有义 务妥善保管其账号及密码，并正确、安全地使用其账号及密码。任何一方未尽上述义务导致账号密码遗失、账号被盗等情形而给用户和他人的民事权利造成损害的， 应当承担由此产生的法律责任。</p>
      <p>4.2 用户对登录后所持账号产生的行为依法享有权利和承担责任。</p>
      <p>4.3 用户发现其账号或密码被他人非法使用或有其他使用异常情况的，应及时根据北京棋开德胜科技有限公司公布的处理方式通知北京棋开德胜科技有限公司，并有权通知北京棋开德胜科技有限公司采取措施暂停该账号的登录和使用。</p>
      <p>4.4 北京棋开德胜科技有限公司根据用户的通知采取措施暂停用户账号的登录和使用的，北京棋开德胜科技有限公司应当要求用户提供并核实与其注册身份信息相一致的个人有效身份信息。</p>
      <p>4.4.1 北京棋开德胜科技有限公司核实用户所提供的个人有效身份信息与所注册的身份信息相一致的，应当及时采取措施暂停用户账号的登录和使用。</p>
      <p>4.4.2 北京棋开德胜科技有限公司违反4.4.1款项的约定，未及时采取措施暂停用户账号的登录和使用，因此而给用户造成损失的，应当承担其相应的法律责任。</p>
      <p>4.4.3 用户没有提供其个人有效身份证件或者用户提供的个人有效身份证件与所注册的身份信息不一致的，北京棋开德胜科技有限公司有权拒绝用户上述请求。</p>
      <p>4.5 用户为了维护其合法权益，向北京棋开德胜科技有限公司提供与所注册的身份信息相一致的个人有效身份信息时，北京棋开德胜科技有限公司应当为用户提供账号注册人证明、原始注册信息等必要的协助和支持，并根据需要向有关行政机关和司法机关提供相关证据信息资料。</p>
      <p>4.6 北京棋开德胜科技有限公司要求用户提供与其个人身份有关的信息资料时，应当事先以明确而易见的方式向用户公开其隐私权保护政策和个人信息利用政策，并采取必要措施保护用户 的个人信息资料的安全。未经用户许可北京棋开德胜科技有限公司不得向任何第三方提供、公开或共享用户注册资料中的姓名、个人有效身份证件号码、联系方式、家庭住址等个人身 份信息，但下列情况除外：</p>
      <p>4.6.1 用户或用户监护人授权北京棋开德胜科技有限公司披露的；</p>
      <p>4.6.2 有关法律要求北京棋开德胜科技有限公司披露的；</p>
      <p>4.6.3 司法机关或行政机关基于法定程序要求北京棋开德胜科技有限公司提供的；</p>
      <p>4.6.4 北京棋开德胜科技有限公司为了维护自己合法权益而向用户提起诉讼或者仲裁时；</p>
      <p>4.6.5 应用户监护人的合法要求而提供用户个人身份信息时。</p>
      <p>4.7除4.6条所述之外情形外，用户同意北京棋开德胜科技有限公司及其关联企业或合作对象，可以在合理范围内搜集、分析、处理、保存、传递及使用用户注册信息，以提供用户其它信息及服务，或进行网络行为的调查或研究，或其它任何合法使用。</p>
      <p>4.8 当用户要求北京棋开德胜科技有限公司给予任何技术上的协助时，用户授权北京棋开德胜科技有限公司远程检视与更改用户计算机的内容。为了更新程序的需要，用户授权北京棋开德胜科技有限公司</p>
      (a)从用户的计算机上传档案/文件/程序；
      (b)下载档案/文件/程序到用户的计算机。
      <p>5. 用户使用服务的限制</p>
      <p>5.1 用户对北京棋开德胜科技有限公司服务管理人员所进行的询问应据实澄清，否则北京棋开德胜科技有限公司有权随时终止用户使用服务；北京棋开德胜科技有限公司发现不法或可疑的行为者，北京棋开德胜科技有限公司有权随时通报司法 或相关机关处理，并有权同时向该机关呈报用户的注册资料及行为供该等机关实施调查。用户就因此所致生的不便、困扰或损害，不得向北京棋开德胜科技有限公司请求任何损害或补 偿。</p>
      <p>5.2 用户应就其在使用北京棋开德胜科技有限公司所提供的服务过程中的行为或活动自行承担全部责任。</p>
      <p>5.3 下列行为将视为用户违反本协议之行为：</p>
      (a)用户所提供的个人资料不真实；
      (b)用户使用任何第三方程序登录或使用服务；
      (c)用户滥用所享受的权利或通过不正当手段使用北京棋开德胜科技有限公司的服务；
      (d)用户有损害其他用户合法权益的行为；
      (e)用户发布违法信息、严重违背社会公德、以及其它违反法律、法规禁止性规定的行为；
      (f)用户违反了本协议及北京棋开德胜科技有限公司关于网络游戏服务发布的其他任何规定。
      对于用户的上述违约行为，北京棋开德胜科技有限公司有权立即中止或终止对用户提供部分或全部服务，并保留追究用户法律责任的权利。
      <p>5.5 为了保护账号安全，此类账号暂时停用功能，如再次登录，可用邮箱或手机号进行激活。</p>
      <p>5.6 乙方提供虚假注册身份信息，或实施违反本协议的行为，甲方有权中止对乙方提供全部或部分服务；北京棋开德胜科技有限公司采取中止措施应当通知用户并告知中止期间，中止期间应该是合理的，中止期间届满北京棋开德胜科技有限公司应当及时恢复对用户的服务。</p>
      <p>5.7 北京棋开德胜科技有限公司根据本条约定中止或终止对用户提供部分或全部服务的，北京棋开德胜科技有限公司负举证责任。</p>
      <p>5.8用户在使用北京棋开德胜科技有限公司产品和接受北京棋开德胜科技有限公司服务的过程中，应当遵循以下原则：</p>
      （1）遵守中华人民共和国有关的法律和法规；
      （2）不得为任何非法目的而使用服务系统；
      （3）遵守所有与服务有关的网络协议、规定和程序；
      （4）不得对包括但不仅限于北京棋开德胜科技有限公司的网站及提供的软件进行修改，还原工程(Reverse Engineering)，译码(Decompile)，反向组译(Disassemble)、复制(copy)或散布(distribute)；
      （5）不得采取任何可能影响北京棋开德胜科技有限公司的网络服务的非正常使用行为（包括但不限于损害、攻击服务器或使服务器过度负荷等）；
      （6）不得通过第三方软件或在第三方软件的辅助下使用北京棋开德胜科技有限公司旗下的所有产品或接受北京棋开德胜科技有限公司的服务；不得采取任何破坏游戏规则和违反游戏公平性的行为；
      （7）未经北京棋开德胜科技有限公司书面许可，不得使用北京棋开德胜科技有限公司任何知识产权，来创造或提供相同或类似的网络服务，如仿真服务器、私人服务器等；
      （8）不得利用北京棋开德胜科技有限公司产品和网络服务系统进行任何可能对互联网的正常运转造成不利影响或可能干扰他人以正常方式使用北京棋开德胜科技有限公司所提供的产品和网络服务的行为；
      （9）不得利用北京棋开德胜科技有限公司网络服务系统传输任何骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的、欺诈性的或其他任何非法的信息资料；
      （10）不得利用北京棋开德胜科技有限公司服务系统进行其他不利于北京棋开德胜科技有限公司的行为；
      （11）不得使用从非由北京棋开德胜科技有限公司指定的渠道所获得的资料或信息；
      （12）就北京棋开德胜科技有限公司及合作商业伙伴的服务、产品、业务咨询应采取北京棋开德胜科技有限公司指定的客户服务渠道和其他专门沟通渠道，不得在公众场合发布有关北京棋开德胜科技有限公司及其相关服务的负面宣传；
      （13）如发现任何非法使用用户账号或账号出现安全漏洞的情况，应立即通告北京棋开德胜科技有限公司；
      （16）当用户账户涉嫌盗号、外挂等非法和违规行为时，用户应配合北京棋开德胜科技有限公司员工的工作，据实回答游戏管理人员提出的与使用北京棋开德胜科技有限公司产品相关的问题，以维护自己和其他用户在游戏中的合法权益；
      （18）不得利用北京棋开德胜科技有限公司所提供的产品和服务在现实生活中获得盈利；
      （19）不得通过各种方式、行为冒充北京棋开德胜科技有限公司向其他用户散布或传播任何信息；
      （20）不得通过各种方式、行为散布或传播网络游戏代练的信息；
      （21）不得利用北京棋开德胜科技有限公司的服务或产品发送或传播敏感信息和违反国家法律制度的信息，包括但不限于：
      (a)反对宪法所确定的基本原则的；
      (b)危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
      (c)损害国家荣誉和利益的；
      (d)煽动民族仇恨、民族歧视，破坏民族团结的；
      (e)破坏国家宗教政策，宣扬邪教和封建迷信的；
      (f)散布谣言，扰乱社会秩序，破坏社会稳定的；
      (g)散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
      (h)使用任何名称、称号侮辱或者诽谤他人， 侵害他人合法权益的
      (i)含有法律、行政法规禁止的其他内容的。
      如有违反以上相关，北京棋开德胜科技有限公司根据情况有可能做出以下惩罚措施：警告；禁言；暂时冻结账号；永久冻结账号。
      <p>5.10用户同意以游戏程序中的监测数据作为判断用户是否有通过使用外挂程序等方法进行的游戏作 弊行为的依据。如果北京棋开德胜科技有限公司发现用户数据异常，北京棋开德胜科技有限公司有权采取相应措施：包括但不限于对游戏帐号的冻结、封停、终止直至删除，以及对涉及使用外挂的游戏 角色的隔离、封停和删除；对涉及使用外挂的游戏角色拥有的虚拟物品进行冻结或收回。基于上述行为而被北京棋开德胜科技有限公司冻结、终止、删除帐号、游戏角色、 虚拟物品或采取其他限制措施的用户，无权因此要求北京棋开德胜科技有限公司承担任何责任。</p>
      <p>5.11用户理解并同意，北京棋开德胜科技有限公司提供游戏产品和游戏服务的目的，是为了让用户体验丰富多彩的游 戏内容，而非利用游戏内容赚取金钱或牟取利益。同时，用户不以体验游戏内容为目的，而是在游戏主要进行交易和牟利行为，会破坏游戏内经济系统的公平性或平 衡性。因此，用户承诺其不能以营利为目的从事游戏行为或交易游戏虚拟物品，任何以营利为目的的游戏虚拟物品交易或牟利情形将被视为牟取不正当利益，包括但 不限于用户：</p>
      （1）注册多个用户帐号或游戏角色ID，以营利为目的进行游戏行为；
      （2）从事游戏内单一或系列产出玩法，将获得的虚拟物品出售获利；
      （3）利用不同服务器的虚拟物品价值差异，在不同服务器买卖虚拟物品获利；
      （4）充当游戏帐号、虚拟物品交易中介收取费用获利；
      （5）在非北京棋开德胜科技有限公司提供或认可的交易平台上交易用户帐号或虚拟物品获利；
      （6）将游戏内获得的虚拟物品用于出售获利而不注重本身角色实力的提升，角色多个技能、修炼、装备、召唤兽水平与角色等级相差较大的；
      （7）利用游戏行为和游戏内容组织或参与赌博、实施或参与实施盗窃他人财产或虚拟物品等涉嫌违法犯罪行为的；
      （8）将购买或其他方式获得的游戏帐号、游戏角色进行拆解，通过出售角色、游戏角色所装备的游戏虚拟物品，或者通过将游戏帐号所包含的点卡数额进行套现的获利行为；
      （9）其他任何不以正常的游戏娱乐互动需要为目的的游戏内牟利行为。北京棋开德胜科技有限公司有权对牟取不正当利 益的用户同时采取以下措施：对所有参与牟取不正当利益的相关帐号（包括但不限于获得、转移、出售游戏道具的帐号）进行倒扣数值、回收游戏道具、暂时隔离、 永久隔离、强制离线、封停帐号、删除档案及采取其他技术措施防止用户从事该等行为；情节严重的，北京棋开德胜科技有限公司保留追究用户法律责任的权利。
      <p>5.12 北京棋开德胜科技有限公司将按照相关法律法规和本协议的规定，采取切实有效的措施保护未成年人在使用北京棋开德胜科技有限公司游戏服务过程中的合法权益，包括可能采取技术措施、禁止未成年 人接触不适宜的游戏或游戏功能、限制未成年人的游戏时间、预防未成年人沉迷网络。所有未成年人用户都应在法定监护人的指导下仔细阅读并遵照执行这些指引和 说明；其他用户在使用北京棋开德胜科技有限公司游戏服务的过程中应避免发布、产生任何有损未成年人身心健康的内容，共同营造健康游戏环境。</p>
      <p>6.服务的停止、中断和变更</p>
      <p>6.1 发生下列情形之一时，北京棋开德胜科技有限公司有权停止或中断向用户提供服务：</p>
      (a)对于网络设备进行必要的保养及施工；
      (b)发生突发性的网络设备故障时；
      (c)北京棋开德胜科技有限公司所用的网络通信设备由于不明原因停止，无法提供服务时；
      (d)不可抗力因素致使北京棋开德胜科技有限公司无法提供线上服务；
      (e)相关政府机构的要求；
      (f)利用程序的漏洞和错误（Bug）破坏游戏的正常进行或传播该漏洞或错误（Bug）；该种情形下官方有权冻结或者封停该用户帐号，对于情节特别严重者可提取法律诉讼。
      <p>6.3 用户应了解并同意，北京棋开德胜科技有限公司所提供的服务可能因公司本身、其它合作厂商或相关电信网络系统软硬件设备的故障、失灵，或因合作方及相关电信工作人员人为操作 的疏失而全部或一部分中断、暂时无法使用，迟延或因他人侵入北京棋开德胜科技有限公司系统篡改或伪造变造资料等，造成服务的停止或中断或用户档案缺失，用户不得要求北京棋开德胜科技有限公司就此提供任何的补偿或赔偿。</p>
      <p>8.风险承担</p>
      <p>用户同意使用北京棋开德胜科技有限公司所提供的服务是出于用户个人意愿，并愿自负风险，包括但不限于其因使用北京棋开德胜科技有限公司服务或自行由北京棋开德胜科技有限公司官方网站或北京棋开德胜科技有限公司相关游戏官方网站下载游戏或资料图片而导致用户或其所使用的计算机系统非因北京棋开德胜科技有限公司主观造成的损害，或发生任何资料的流失等。</p>
      <p>9.责任免除及赔偿责任限制</p>
      <p>9.1 北京棋开德胜科技有限公司就其所提供的服务，不负任何明示或默示的担保责任，而其所提供的服务的稳定、安全、无误及不中断性亦有可能因本协议第6条所述情形而受到影响。用 户应自行承担使用服务所有的风险及因此可能导致的损害，包括但不限于其因使用北京棋开德胜科技有限公司服务或自行由北京棋开德胜科技有限公司官方网站或北京棋开德胜科技有限公司相关游戏官方网站下载游戏或 资料图片而导致用户或其所使用的计算机系统非因北京棋开德胜科技有限公司过错造成的损害，或发生任何资料的流失等。</p>
      <p>9.2 北京棋开德胜科技有限公司对其服务不保证不出现任何程序BUG，并对由此可能产生的问题不承担任何赔偿责任。</p>
      <p>9.3北京棋开德胜科技有限公司在其公司网站的所有网页上所提供的所有链接，可能链接到其它个人、公司或组织的网 站，提供该等网站的目的，是便利用户自行搜寻或取得信息，北京棋开德胜科技有限公司对于被链接的个人、公司或组织的网站所提供的产品、服务或信息，不担保其真实性、完整 性、实时性或可信度，除非有特别说明，这些个人、公司或组织与北京棋开德胜科技有限公司间亦不存在任何雇用、委任、代理、合伙或其它类似的关系。如用户因该等链接而遭受损 失，北京棋开德胜科技有限公司不承担任何责任。</p>
      <p>9.4北京棋开德胜科技有限公司对于用户使用其服务或无法使用网络所导致的任何直接、间接、衍生的损害或所失利益不负任何损害赔偿责任。若按法律强制性规定北京棋开德胜科技有限公司确需对此承担损害赔偿责任时，北京棋开德胜科技有限公司的赔偿责任亦以用户就使用服务所支付北京棋开德胜科技有限公司的价款为限。</p>
      <p>9.5 北京棋开德胜科技有限公司提供的服务为互联网服务，可能会受到各个环节不稳定因素的影响，存在因不可抗力、计算机病毒、黑客攻击、系统不稳定、用户所在位置、用户关机、非 法内容信息、骚扰信息屏蔽以及其他任何网络、技术、通信线路、信息安全管理措施等原因造成的服务中断、受阻等不能满足用户要求的风险，用户须明白并自行承 担以上风险。</p>
      <p>10.北京棋开德胜科技有限公司的终止权</p>
      <p>10.1用户应确实遵守本协议及有关法律命令的规定。若北京棋开德胜科技有限公司经相关数据分析认定用户违反本协议，用户同意北京棋开德胜科技有限公司可以随时终止用户的账号及密码使用权。</p>
      <p>10.2为避免争议，本协议涉及到的有关技术方面的问题，用户同意以北京棋开德胜科技有限公司系统所记载的数据作为判断标准，且该数据是唯一的、排他的结果。北京棋开德胜科技有限公司保证该数据的真实性且该数据未经政府有关部门要求，不向包括用户在内的任何人披露。</p>
      <p>11.损害赔偿</p>
      <p>用户若违反协议或相关法令，导致北京棋开德胜科技有限公司、其关系联方、受雇人、受托人、代理人及其它相关辅助人因此而受到损害或支出费用（包括但不限于因法律诉讼、行政程序等所支出的诉讼费用、律师费用、实际遭受损失的费用等），用户应负担损害赔偿责任。</p>
      <p>12.广告信息和促销计划</p>
      <p>12.1 北京棋开德胜科技有限公司在提供服务过程中可能在有关网站位置上刊登商业广告或其它活动促销的广告。这些内容系广告商或商品服务提供者所为，北京棋开德胜科技有限公司仅是刊登内容的媒介。 用户通过北京棋开德胜科技有限公司官方网站或其所链接的网站所购买的服务或商品，其交易行为仅存于用户与该商品或服务的提供者之间，与北京棋开德胜科技有限公司无关，北京棋开德胜科技有限公司不承担因用户交易而产生的任何责任。</p>
      <p>12.2 北京棋开德胜科技有限公司在提供服务过程可能以电子邮件方式不时向用户发送北京棋开德胜科技有限公司的游戏电子期刊或相关市场活动信息，如用户不愿意收到类似电子邮件，可点击邮件中的退订链接，完成退订手续。</p>
      <p>13.协议的修改</p>
      <p>13.1 由于行业政策及法律法规的不断变化和发展，北京棋开德胜科技有限公司保留随时修改本协议的权利，修改本协议时，北京棋开德胜科技有限公司将于相关页面公告修改的事实，而不另行对用户进行个别通知。用户可以在北京棋开德胜科技有限公司的相关页面查阅最新版本的协议条款。</p>
      <p>13.2 本协议条款变更后，如果用户继续使用北京棋开德胜科技有限公司服务，即视为已接受变更后的协议。如果用户不接受变更后的协议，应当停止使用北京棋开德胜科技有限公司服务。</p>
      <p>13.3 本协议的修改和解释权归属于北京棋开德胜科技有限公司。</p>
      <p>14.适用法律及争议解决</p>
      <p>14.1 本协议所定的任何条款部分或全部无效，不影响其它条款的效力。</p>
      <p>14.2 本协议的所有标题仅是为了醒目及阅读方便，本身并无实际涵义，不作为本协议涵义解释之依据。</p>
      <p>14.3 本协议签订地为北京市海淀区。本协议的解释、效力及纠纷的解决，适用于中华人民共和国法律。若用户和北京棋开德胜科技有限公司之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，双方同意将纠纷或争议提交合同签订地人民法院诉讼管辖。</p>
      <p>健康游戏忠告：抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。</p>
      <p>版权所有：北京棋开德胜科技有限公司</p>
      <p>公司地址: 北京市海淀区 </p>
    </div>
  <!--  <div style="text-align: center;margin-bottom: 40px" ><el-button type="primary" class="btn_read">我已阅读</el-button></div>-->

  </div>
</template>

<script>
  export default {
    data() {
      return {
        isLogin:false
      }
    },
    components:{
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../components/style/mixin';
  .navbar{
    position: relative;
    width: 100%;
    min-width: 1000px;
    height:75px;
    color: #fff;
    background-color:#303030;
    margin-top: -5px;
    .nav_wrapper{
      position:relative;
      height:100%;
      background: url('../../images/navbar.png') no-repeat center center;
      .title{
        position:relative;
        padding:20px 0px 20px 20px;
        font-weight:bolder;
        font-size:26px;
        color:#fff;
      }
      .title:before{
        position: absolute;
        top: 26px;
        left:0px;
        bottom: 1px;
        display: inline-block;
        content: '';
        height:24px;
        content:'';
        border-left:4px solid #ffdb17;
        margin-right:28px;
      }
    }
  }
  .argeement{padding: 30px  300px}
  .argeement p{margin-top: 10px}
  .title1{font-size: 26px;font-weight: bold}
  .title2{font-weight: bold;font-size: 20px}
</style>
